import { AnalyticsEventJourneyKey, AnalyticsJourneyKey } from 'core/enums/analytics-journey-key';
import { Product } from 'core/models/product/product';
import { Util } from 'utils/common.utils';

export type AnalyticsModel = { [key: string]: string | number | boolean };

export const AnalyticsEventsJourney: any = {
  [AnalyticsJourneyKey.AccountDashboard]: {
    [AnalyticsEventJourneyKey.BeginCheckout]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BeginCheckout,
      ecommerce: {
        currency: info?.account?.amountToPay?.currencyCode,
        value: info?.account?.amountToPay?.value,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name: 'DStv Payment',
            item_id: 'DSTVPAYMENT',
            price: info?.account?.amountToPay?.value,
            item_category: 'PAYMENT',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.Purchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.Purchase,
      ecommerce: {
        currency: info?.account?.amountToPay?.currencyCode,
        value: info?.account?.amountToPay?.value,
        transaction_id: info?.transactionId,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name: 'DStv Payment',
            item_id: 'DSTVPAYMENT',
            price: info?.account?.amountToPay?.value,
            item_category: 'PAYMENT',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.PurchaseFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.PurchaseFailure,
      ecommerce: {
        currency: info?.currencyCode,
        value: info?.amount,
        transaction_id: info?.transactionId,
        payment_type: info?.paymentMethod,
        page_url: info?.pageUrl,
        entry_point: info?.analyticsEntryPoint,
        ecom_error_message: info?.errorMessage || undefined,
        items: [
          {
            item_name: 'DStv Payment',
            item_id: 'DSTVPAYMENT',
            price: info?.amount,
            item_category: 'PAYMENT',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.AppLoad]: {
    [AnalyticsEventJourneyKey.Purchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.Purchase,
      ecommerce: {
        currency: info?.currencyCode,
        value: info?.amount,
        transaction_id: info?.transactionId,
        payment_type: info?.paymentMethod,
        page_url: info?.pageUrl,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name: 'DStv Payment',
            item_id: 'DSTVPAYMENT',
            price: info?.amount,
            item_category: 'PAYMENT',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.PurchaseFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.PurchaseFailure,
      ecommerce: {
        currency: info?.currencyCode,
        value: info?.amount,
        transaction_id: info?.transactionId,
        payment_type: info?.paymentMethod,
        page_url: info?.pageUrl,
        entry_point: info?.analyticsEntryPoint,
        ecom_error_message: info?.errorMessage || undefined,
        items: [
          {
            item_name: 'DStv Payment',
            item_id: 'DSTVPAYMENT',
            price: info?.amount,
            item_category: 'PAYMENT',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.ProductSubscription]: {
    [AnalyticsEventJourneyKey.BeginCheckout]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BeginCheckout,
      ecommerce: {
        currency: info?.currency,
        value: info?.price,
        entry_point: info?.analyticsEntryPoint,
        items: info?.products
          ?.filter((product: Product) => product?.serviceName)
          ?.map((item: Product) => {
            return {
              item_name: item?.productName || item?.description || item?.serviceDescription || item?.serviceName,
              item_id: item?.serviceName,
              price: item?.price,
              item_category: item?.agreementType,
              item_list_name: '',
              quantity: 1,
            };
          }),
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.Purchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.Purchase,
      ecommerce: {
        currency: info?.currency,
        value: info?.value,
        transaction_id: info?.transactionId,
        entry_point: info?.analyticsEntryPoint,
        items: info?.products
          ?.filter((product: Product) => product?.serviceName)
          ?.map((item: Product) => {
            return {
              item_name: item?.productName || item?.description || item?.serviceDescription || item?.serviceName,
              item_id: item?.serviceName,
              price: item?.price,
              item_category: item?.agreementType,
              item_list_name: '',
              quantity: 1,
            };
          }),
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.PurchaseFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.PurchaseFailure,
      ecommerce: {
        currency: info?.currencyCode,
        value: info?.value,
        transaction_id: info?.transactionId,
        ecom_error_message: info?.errorMessage || undefined,
        entry_point: info?.analyticsEntryPoint,
        items: info?.products
          ?.filter((product: Product) => product?.serviceName)
          ?.map((item: Product) => {
            return {
              item_name: item?.productName || item?.description || item?.serviceDescription || item?.serviceName,
              item_id: item?.serviceName,
              price: item?.price,
              item_category: item?.agreementType,
              item_list_name: '',
              quantity: 1,
            };
          }),
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.UnbundledPurchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.Purchase,
      ecommerce: {
        currency: info?.currency,
        value: info?.value,
        transaction_id: info?.transactionId,
        journey_name: info?.journey_name,
        entry_point: info?.analyticsEntryPoint,
        items: info?.products
          ?.filter((product: Product) => product?.serviceName)
          ?.map((item: Product) => {
            return {
              item_name: item?.productName || item?.description || item?.serviceDescription || item?.serviceName,
              item_id: item?.serviceName,
              price: item?.price,
              item_category: item?.agreementType,
              item_list_name: '',
              quantity: 1,
            };
          }),
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.AddPaymentInfo]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.AddPaymentInfo,
      ecommerce: {
        currency: info?.currency,
        value: info?.amountToPay,
        items: info?.products
          ?.filter((product: Product) => product?.serviceName)
          ?.map((item: Product) => {
            return {
              item_name: item?.productName,
              item_id: item?.serviceName,
              price: item?.price,
              item_category: item?.agreementType,
              item_list_name: '',
              quantity: 1,
            };
          }),
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.SelfServiceProductSwitcher]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.SelfServiceProductSwitcher,
      bundle_name: info?.productName,
      bundle_state: info?.status,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceSuccess,
      bundle_name: info?.productName || info?.description || info?.serviceDescription || info?.serviceName,
      bundle_service: info?.serviceName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleServiceFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceFailure,
      bundle_name: info?.productName || info?.description || info?.serviceDescription || info?.serviceName,
      bundle_service: info?.serviceName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleAddOnServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleAddOnServiceSuccess,
      bundle_name: info?.productName,
      bundle_service: `${info?.serviceName} - ${info?.addons}`,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleAddOnServiceFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleAddOnServiceFailure,
      bundle_name: info?.productName,
      bundle_service: `${info?.serviceName} - ${info?.addons}`,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleAddonSwitcher]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleAddonSwitcher,
      bundle_name: info?.productName,
      bundle_state: info?.status,
      linked_package: info?.serviceName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.OnDemandService]: {
    [AnalyticsEventJourneyKey.RentMovies]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.RentMovies,
      status: info?.status,
      current_page_url: info?.url,
      context: info?.context,
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.ProductHardware]: {
    [AnalyticsEventJourneyKey.DecoderServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.DecoderServiceSuccess,
      bundle_name: info?.productName,
      decoder: info?.serviceName,
      current_page_url: info?.url,
      context: info?.context,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BeginCheckout]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BeginCheckout,
      ecommerce: {
        currency: info?.currency,
        value: info?.price,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name: 'DStv XtraView',
            item_id: 'DSTVXTRAVIEW',
            price: info?.price,
            item_category: 'HARDWARE',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.Purchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.Purchase,
      ecommerce: {
        currency: info?.currencyCode,
        value: info?.amount,
        transaction_id: info?.transactionId,
        page_url: info?.url,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name: 'DStv XtraView',
            item_id: 'DSTVXTRAVIEW',
            price: info?.amount,
            item_category: 'HARDWARE',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.PurchaseFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.PurchaseFailure,
      ecommerce: {
        currency: info?.currencyCode,
        value: info?.amount,
        transaction_id: info?.transactionId,
        page_url: info?.url,
        entry_point: info?.analyticsEntryPoint,
        ecom_error_message: info?.errorMessage || undefined,
        items: [
          {
            item_name: 'DStv XtraView',
            item_id: 'DSTVXTRAVIEW',
            price: info?.amount,
            item_category: 'HARDWARE',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceSuccess,
      bundle_name: info?.decoder,
      product_name: info?.productName,
      bundle_service: 'decoder_service',
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleServiceFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceFailure,
      bundle_name: info?.decoder,
      product_name: info?.productName,
      bundle_service: 'decoder_service',
      context: info?.context,
      current_page_url: info?.url,
      error_message: info?.errorMessage || undefined,
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.ProductInternet]: {
    [AnalyticsEventJourneyKey.InternetServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.InternetServiceSuccess,
      internet_name: info?.productName,
      internet_service: info?.serviceName,
      current_page_url: info?.url,
      context: info?.context,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.InternetServiceFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.InternetServiceFailure,
      internet_name: info?.productName,
      internet_service: info?.serviceName,
      current_page_url: info?.url,
      context: info?.context,
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.ProductExtraStream]: {
    [AnalyticsEventJourneyKey.ExtraStreamSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceSuccess,
      internet_name: info?.productName,
      internet_service: info?.serviceName,
      current_page_url: info?.url,
      context: info?.context,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.ExtraStreamFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceFailure,
      internet_name: info?.productName,
      internet_service: info?.serviceName,
      current_page_url: info?.url,
      context: info?.context,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BeginCheckout]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BeginCheckout,
      ecommerce: {
        currency: info?.currency,
        value: info?.price,
        entry_point: info?.analyticsEntryPoint,
        items: info?.products
          ?.filter((product: Product) => product?.serviceName !== undefined)
          ?.map((item: Product) => {
            return {
              item_name: item?.productName,
              item_id: item?.serviceName,
              price: info?.price,
              item_category: item?.agreementType,
              item_list_name: '',
              quantity: info?.streamQuantity,
            };
          }),
      },
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.ProductInsurance]: {
    [AnalyticsEventJourneyKey.FSPServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FSPServiceSuccess,
      product_name: info?.productName,
      bundle_service: 'fsp_service',
      current_page_url: info?.url,
      context: info?.context,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.FSPServiceFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FSPServiceFailure,
      product_name: info?.productName,
      bundle_service: 'fsp_service',
      current_page_url: info?.url,
      context: info?.context,
      error_message: info?.errorMessage,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.FreshdeskFormSubmitSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FreshdeskFormSubmitSuccess,
      current_page_url: info?.url,
      call_back_form: info?.formName,
      form_email: Util.convertToHash(info?.email),
      form_phone: Util.convertToHash(info?.phoneNumber),
      form_first_name: Util.convertToHash(info?.name),
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.FreshdeskFormSubmitFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FreshdeskFormSubmitFailure,
      current_page_url: info?.url,
      call_back_form: info?.formName,
      form_email: Util.convertToHash(info?.email),
      form_phone: Util.convertToHash(info?.phoneNumber),
      form_first_name: Util.convertToHash(info?.name),
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BeginCheckout]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BeginCheckout,
      ecommerce: {
        currency: info?.currency,
        value: info?.value,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name: info?.product?.productName,
            item_id: info?.product?.serviceName,
            price: info?.product?.price,
            item_category: 'fsp_product',
            item_list_name: 'Insurance Products',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.Purchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.Purchase,
      ecommerce: {
        currency: info?.currency,
        value: info?.value,
        transaction_id: info?.transactionId,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name:
              info?.productName ||
              info?.product?.productName ||
              info?.product?.description ||
              info?.product?.serviceDescription ||
              info?.product?.serviceName,
            item_id: info?.serviceId || info?.product?.serviceName,
            price: info?.price,
            item_category: 'fsp_product',
            item_list_name: 'Insurance Products',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.PurchaseFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.PurchaseFailure,
      ecommerce: {
        currency: info?.currency,
        value: info?.value,
        transaction_id: info?.transactionId,
        ecom_error_message: info?.errorMessage || undefined,
        entry_point: info?.analyticsEntryPoint,
        items: [
          {
            item_name:
              info?.productName ||
              info?.product?.productName ||
              info?.product?.description ||
              info?.product?.serviceDescription ||
              info?.product?.serviceName,
            item_id: info?.serviceId || info?.product?.serviceName,
            price: info?.price,
            item_category: 'fsp_product',
            item_list_name: 'Insurance Products',
            quantity: 1,
          },
        ],
      },
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.DstvActivate]: {
    [AnalyticsEventJourneyKey.BeginCheckout]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BeginCheckout,
      ecommerce: {
        currency: info?.account?.amountToPay?.currencyCode,
        value: info?.account?.amountToPay?.value,
        items: info?.products
          ?.filter((product: Product) => product.productId !== undefined)
          ?.map((item: Product) => {
            return {
              item_name: item?.productName,
              item_id: item?.serviceName,
              price: item?.price,
              item_category: item?.agreementType,
              item_list_name: '',
              quantity: 1,
            };
          }),
      },
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.Purchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.Purchase,
      ecommerce: {
        currency: info?.account?.amountToPay?.currencyCode,
        value: info?.account?.amountToPay?.value,
        entry_point: info?.analyticsEntryPoint,
        transaction_id: '',
      },
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.FixError]: {
    [AnalyticsEventJourneyKey.FixErrorSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FixErrorSuccess,
      error_code: info?.ErrorCode,
      current_page_url: info?.url,
      context: 'Fix Error',
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.FixErrorFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FixErrorFailure,
      error_code: info?.ErrorCode,
      current_page_url: info?.url,
      context: 'Fix Error',
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.SubscriptionPriceLock]: {
    [AnalyticsEventJourneyKey.SubscriptionPriceLockPurchase]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.SubscriptionPriceLockPurchase,
      error_code: info?.ErrorCode,
      current_page_url: info?.url,
      bundle_name: info?.productName,
      bundle_service: info?.serviceName,
      ecommerce: {
        currency: info?.currencyStore?.mainCurrency?.code,
        value: info?.amount?.value,
        transaction_id: info?.transactionId,
        items: [
          {
            item_name: 'DStv Payment',
            item_id: 'DSTVPAYMENT',
            price: info?.amount?.value,
            item_category: 'PAYMENT',
            quantity: 1,
          },
        ],
      },
      context: 'Subscription Price Lock',
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.SubscriptionPriceLockSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.SubscriptionPriceLockSuccess,
      bundle_name: info?.productName,
      bundle_service: info?.serviceName,
      error_code: info?.ErrorCode,
      current_page_url: info?.url,
      context: 'Subscription Price Lock',
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.SubscriptionPriceLockFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.SubscriptionPriceLockFailure,
      bundle_name: info?.productName,
      bundle_service: info?.serviceName,
      error_code: info?.ErrorCode,
      current_page_url: info?.url,
      context: 'Subscription Price Lock',
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.UpdatePaymentMethod]: {
    [AnalyticsEventJourneyKey.DebitOrderSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.DebitOrderSuccess,
      service_name: 'Update Methods of payment',
      context: 'Web Debit Order',
      current_page_url: info?.url,
    }),
    [AnalyticsEventJourneyKey.CreditCardSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.CreditCardSuccess,
      service_name: 'Update Methods of payment',
      context: 'Web Credit Card',
      current_page_url: info?.url,
    }),
    [AnalyticsEventJourneyKey.CashSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.CashSuccess,
      service_name: 'Update Methods of payment',
      context: 'Web Cash',
      current_page_url: info?.url,
    }),
    [AnalyticsEventJourneyKey.DebitOrderFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.DebitOrderFailure,
      service_name: 'Update Methods of payment',
      context: 'Web Debit Order',
      current_page_url: info?.url,
      reason: info?.reason,
    }),
    [AnalyticsEventJourneyKey.CreditCardFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.CreditCardFailure,
      service_name: 'Update Methods of payment',
      context: 'Credit Card Order',
      current_page_url: info?.url,
      reason: info?.reason,
    }),
    [AnalyticsEventJourneyKey.CashFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.CashFailure,
      service_name: 'Update Methods of payment',
      context: 'Cash Order',
      current_page_url: info?.url,
      reason: info?.reason,
    }),
  },
  [AnalyticsJourneyKey.SwitchToContract]: {
    [AnalyticsEventJourneyKey.BundleServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceSuccess,
      bundle_name: info?.productName || info?.description || info?.serviceDescription || info?.serviceName,
      bundle_service: info?.serviceName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.BundleServiceFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceFailure,
      bundle_name: info?.productName || info?.description || info?.serviceDescription || info?.serviceName,
      bundle_service: info?.serviceName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.ContractSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceSuccess,
      bundle_name: info?.bundleName,
      bundle_service: info?.productName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.ContractFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.BundleServiceFailure,
      bundle_name: info?.bundleName,
      bundle_service: info?.productName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.StreamRenewContract]: {
    [AnalyticsEventJourneyKey.StreamRenewContractSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.StreamRenewContractSuccess,
      bundle_name: info?.bundleName,
      bundle_service: info?.productName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.StreamRenewContractFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.StreamRenewContractFailure,
      bundle_name: info?.bundleName,
      bundle_service: info?.productName,
      context: info?.context,
      current_page_url: info?.url,
      ...info?.user,
    }),
  },
  [AnalyticsJourneyKey.Rewards]: {
    [AnalyticsEventJourneyKey.RewardServiceSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.RewardServiceSuccess,
      context: info?.context,
      bundle_service: info?.serviceName,
      current_page_url: info?.url,
      product_name: info?.productName,
      ...info?.user,
    }),
    [AnalyticsEventJourneyKey.RewardServiceFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.RewardServiceFailure,
      context: info?.context,
      bundle_service: info?.serviceName,
      current_page_url: info?.url,
      product_name: info?.productName,
      ...info?.user,
    })
  },
  [AnalyticsJourneyKey.FuneralPolicy]: {
    [AnalyticsEventJourneyKey.FuneralPolicyActivationSuccess]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FuneralPolicyActivationSuccess,
      context: info?.context,
      current_page_url: info?.url,
      product_name: info?.productName
    }),
    [AnalyticsEventJourneyKey.FuneralPolicyActivationFailure]: (info?: any) => ({
      event: AnalyticsEventJourneyKey.FuneralPolicyActivationFailure,
      context: info?.context,
      current_page_url: info?.url,
      product_name: info?.productName
    }),
  },
};